export abstract class FeatureBase {
  public abstract fieldNames: string[];
  
  public abstract initFeatureField(field: Field, formDataEntry: FormDataEntry, fields: Field[]): FormDataEntry;

  getPrefixFromFieldName(text: string): string {
    const regex = new RegExp(`(${this.fieldNames.join('|')})$`, 'g');

    return text.replace(regex, "");
  }
}